import { Tabs } from "@mantine/core";
import { useNavigate } from "react-router";
import { usePermission } from "@how/app-kit";

export type CrmTab = "people" | "households" | "tags" | "consent" | "duplicates";

const PATHS: Record<CrmTab, string> = {
  people: "/people",
  households: "/people/households",
  tags: "/people/tags",
  consent: "/people/consent",
  duplicates: "/people/duplicates",
};

/**
 * The CRM section's tabs, under the page header. People, households and tags are one area rather than three entries
 * in the sidebar: they are the same data seen from three sides, and the sidebar stays a list of places.
 */
export function CrmTabs({ active }: { readonly active: CrmTab }) {
  const navigate = useNavigate();
  // Only the people who can merge are shown the list of candidates to merge.
  const canMerge = usePermission("people.merge", { write: true });
  return (
    <Tabs
      value={active}
      onChange={(value) => {
        if (value !== null && value in PATHS) void navigate(PATHS[value as CrmTab]);
      }}
      mb="lg"
    >
      <Tabs.List>
        <Tabs.Tab value="people">People</Tabs.Tab>
        <Tabs.Tab value="households">Households</Tabs.Tab>
        <Tabs.Tab value="tags">Tags</Tabs.Tab>
        <Tabs.Tab value="consent">Who we can contact</Tabs.Tab>
        {canMerge.data === true ? <Tabs.Tab value="duplicates">Duplicates</Tabs.Tab> : null}
      </Tabs.List>
    </Tabs>
  );
}
